import { render } from "./FailedItem.vue?vue&type=template&id=222aeb68&scoped=true&ts=true"
import script from "./FailedItem.vue?vue&type=script&lang=ts"
export * from "./FailedItem.vue?vue&type=script&lang=ts"

import "./FailedItem.vue?vue&type=style&index=0&id=222aeb68&scoped=true&lang=css"

import exportComponent from "/builds/custom-client/enablewa-token-refresher/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222aeb68"]])

export default __exports__